import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=4e77002f&scoped=true&"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts&"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=4e77002f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e77002f",
  null
  
)

export default component.exports